import { createFileRoute } from '@tanstack/react-router';
import { OutputsView } from '~portal/components/admin/automations/outputs/OutputsView';

/**
 * @desc Automations → Outputs (refine-automations-authoring-ux D8): each workflow's latest
 * successful run's files, with Download, View and the planned "Send to" destinations — sharing is
 * offered here rather than in the chat.
 */
export const Route = createFileRoute('/_protected/admin/ario/outputs')({
  component: OutputsView,
});
